import React, { useMemo } from 'react'

import { t } from 'src/translations'

import { useRestaurantRoutes } from 'shared/components/common/restaurant_routes/RestaurantRoutesContext'
import PrimaryCTA from 'shared/components/primary_cta/PrimaryCTA'

import { useCart } from 'public/components/online_ordering/CartContext'
import { Channel } from 'public/js/siteUtilities'
import { useRestaurant } from 'src/shared/components/common/restaurant_context/RestaurantContext'
import { getLocationPickerPath } from 'src/public/components/pages/location_selection_page/locationSelectionUtils'

const EmptyCart = () => {
  const { channel } = useCart()
  const { orderPath, ecommPath } = useRestaurantRoutes()
  const { ooRestaurant, restaurant } = useRestaurant()
  const locationPickerPath = getLocationPickerPath(
    ooRestaurant?.managementSetGuid || restaurant?.externalId,
    restaurant?.externalRef
  )
  const orderUrl = useMemo(() => {
    if (
      restaurant.locations?.length &&
      restaurant.locations.length > 1 &&
      locationPickerPath
    ) {
      return locationPickerPath
    }
    return orderPath
  }, [locationPickerPath, orderPath, restaurant.locations?.length])

  return (
    <div className='checkoutForm emptyCart'>
      <section className='checkoutSection currentSection'>
        <h2 className='subHeader'>{t('empty-cart.your-cart-is-empty')}</h2>
        <div className='fixedSection'>
          <div>{t('empty-cart.add-items-to-start-your-order')}</div>
        </div>
        <div className='fixedSection'>
          <PrimaryCTA
            href={channel === Channel.ECOMM ? ecommPath : orderUrl}
            sameTab={channel !== Channel.ECOMM}
            text={
              channel === Channel.ECOMM
                ? t('empty-cart.keep-shopping')
                : t('empty-cart.order-online')
            }
          />
        </div>
      </section>
    </div>
  )
}

export default EmptyCart
